"use client";

import { c as _c } from "react/compiler-runtime";
import { graphql } from "@opensea/graphql";
import { useCallback } from "react";
import { useClient } from "urql";
import { useAddress } from "../../../../polychain/hooks";
import { useScheduler_actionFragment } from "../../../../polychain/hooks/useScheduler.fragment";
const query = graphql(`
    query useTransferTokens(
      $chain: ChainIdentifier!
      $contractAddress: Address!
      $quantity: BigDecimal!
      $fromAddress: Address!
      $toAddress: Address!
    ) {
      transferAssetsV2(
        fromAddress: $fromAddress
        toAddress: $toAddress
        assetQuantities: [
          {
            asset: { chain: $chain, contractAddress: $contractAddress }
            quantity: $quantity
          }
        ]
      ) {
        actions {
          ...useScheduler_action
        }
      }
    }
  `, [useScheduler_actionFragment]);
export const useTransferTokens = () => {
  const $ = _c(3);
  const address = useAddress();
  const urqlClient = useClient();
  let t0;
  if ($[0] !== address || $[1] !== urqlClient) {
    t0 = async t1 => {
      const {
        chain,
        contractAddress,
        quantity,
        toAddress
      } = t1;
      if (!address) {
        throw new Error("Address is required");
      }
      const {
        data
      } = await urqlClient.query(query, {
        chain,
        contractAddress,
        quantity,
        fromAddress: address,
        toAddress
      });
      return data?.transferAssetsV2.actions;
    };
    $[0] = address;
    $[1] = urqlClient;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const transfer = t0;
  return transfer;
};